export default "__VITE_ASSET__cBYYzGH5__";